import React from "react";
import PropTypes from "prop-types";
import Overlay from "components/Overlay";
import { MatchScoreDisplay } from "components/Missions/Applicants";
import Score from "components/Score";
import { convertToPercent } from "utils";

/**
 * ApplicantMatchScore
 *
 * @param {Object} scores
 * @param {Number} matchScore
 * @param {Object} scoreData
 */
const ApplicantMatchScore = ({ scores, matchScore, scoreData }) => (
  <Overlay
    asCardOverlay
    overlay={<MatchScoreDisplay scores={scores} scoreData={scoreData} />}
    trigger={<Score score={Number(matchScore) * 100}>{convertToPercent(matchScore)}</Score>}
    placement="top"
  />
);

ApplicantMatchScore.propTypes = {
  scores: PropTypes.object,
  matchScore: PropTypes.number,
  scoreData: PropTypes.object,
};

export default ApplicantMatchScore;
